import { Http } from '../../../support';

const initialState = {
  isValid: false,
  busy: false,
  fetching: false,
  data: {},
  steps: [],
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.admin.clientes.billing = {
      ...state.admin.clientes.billing,
      ...data,
    };
  });
};

const upsert = async (store, data, id) => {
  store.setState((state) => {
    state.admin.clientes.billing.busy = true;
  });

  try {
    let response = await Http.put(`api/clientes/${id}/informacion-fiscal`, data);

    store.setState((state) => {
      state.admin.clientes.billing.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.clientes.billing.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.admin.clientes.billing.busy = false;
    });
  }
};

const _isValid = (steps) => {
  return steps.every((value) => !!value.done);
};

const _getNewStepsAfterVerification = (all, step, valid) => {
  return all.map((item) => {
    const assignable = { ...item };

    if (step.number === assignable.number) {
      assignable.done = valid;
    }

    return assignable;
  });
};

const setStepDataChange = (store, event) => {
  const { billing } = store.state.admin.clientes;

  const steps = _getNewStepsAfterVerification(billing?.steps, event.step, event.isValid);

  const isValid = _isValid(steps);

  store.setState((state) => {
    state.admin.clientes.billing = {
      ...state.admin.clientes.billing,
      data: {
        ...state.admin.clientes.billing.data,
        ...event.data,
      },
      steps,
      isValid,
    };
  });
};

const reset = (store) => {
  store.setState((state) => {
    state.admin.clientes.billing = { ...initialState };
  });
};

const ClienteBillingInfoStore = {
  state: () => initialState,
  actions: {
    reset,
    upsert,
    setPartialState,
    setStepDataChange,
  },
};

export default ClienteBillingInfoStore;
